<script setup>
import { VueFlow } from '@vue-flow/core'
import { Background } from '@vue-flow/background'
import { Controls } from '@vue-flow/controls'
import '@vue-flow/core/dist/style.css'
import '@vue-flow/core/dist/theme-default.css'
import '../workflow-styles.css'

import TriggerNode from '../nodes/TriggerNode.vue'
import EmailNode from '../nodes/EmailNode.vue'
import PushNode from '../nodes/PushNode.vue'
import AddTagNode from '../nodes/AddTagNode.vue'
import ConditionNode from '../nodes/ConditionNode.vue'
import DelayNode from '../nodes/DelayNode.vue'
import WaitUntilNode from '../nodes/WaitUntilNode.vue'
import WaitForDateNode from '../nodes/WaitForDateNode.vue'
import SplitNode from '../nodes/SplitNode.vue'
import GoalNode from '../nodes/GoalNode.vue'
import ExitAllowReentryNode from '../nodes/ExitAllowReentryNode.vue'

const emit = defineEmits(['node-click', 'pane-click', 'drop'])

const nodeTypes = {
    trigger: TriggerNode,
    action_email: EmailNode,
    action_push: PushNode,
    action_add_tag: AddTagNode,
    condition: ConditionNode,
    delay: DelayNode,
    wait_until: WaitUntilNode,
    wait_for_date: WaitForDateNode,
    split: SplitNode,
    goal_check: GoalNode,
    exit_allow_reentry: ExitAllowReentryNode,
}

function onNodeClick(event) {
    emit('node-click', event)
}

function onPaneClick(event) {
    emit('pane-click', event)
}

function onDrop(event) {
    event.preventDefault()
    emit('drop', event)
}

function onDragover(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = 'move'
}
</script>

<template>
    <div class="workflow-canvas-wrap" @drop="onDrop" @dragover="onDragover">
        <VueFlow
            :node-types="nodeTypes"
            fit-view-on-init
            @node-click="onNodeClick"
            @pane-click="onPaneClick"
        >
            <Background />
            <Controls />
        </VueFlow>
    </div>
</template>

<style scoped>
.workflow-canvas-wrap {
    flex: 1;
    height: 100%;
    position: relative;
    overflow: hidden;
}
</style>
